<template>
    <div class="wrap white-bg">
        <div class="box1200">
            <div class="index-title">
                <h3 class="title">加盟我们</h3>
                <p class="sort-title">加盟{{this.$store.state.siteName}} 为企业带来更好的服务</p>
            </div>
            <!-- index-title -->
            <div class="joinBox">
                <div class="join-form">
                    <p class="title">请填写您的联系方式，获取最新的招商加盟方案</p>
                    <el-form ref="ruleForm" :rules="rules" :model="form">
                        <el-form-item prop="name">
                            <el-input v-model="form.name" placeholder="公司名称"></el-input>
                        </el-form-item>
                        <el-form-item prop="nickname">
                            <el-input v-model="form.nickname" placeholder="您的称呼"></el-input>
                        </el-form-item>
                        <el-form-item prop="telephone">
                            <el-input v-model="form.telephone" placeholder="电话号码"></el-input>
                        </el-form-item>
                        <el-form-item prop="area">
                            <el-input v-model="form.area" placeholder="意向加盟区域"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="handelJoin('ruleForm')">提交信息</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {addBusiness} from '@/config/api.js'
    export default {
        name: 'HomeJoinus',
        data () {
            return {
                form: {
                    name: '',
                    nickname: '',
                    telephone: '',
                    area: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入公司名称', trigger: 'blur' }
                    ],
                    nickname: [
                        { required: true, message: '请输入您的称呼', trigger: 'blur' }
                    ],
                    telephone: [
                        { required: true, message: '请输入电话号码', trigger: 'blur' }
                    ],
                    area: [
                        { required: true, message: '请输入意向加盟区域', trigger: 'blur' }
                    ],
                }
            }
        },
    methods: {
        handelJoin (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = {
                        name: this.form.name,
                        nickname: this.form.nickname,
                        telephone: this.form.telephone,
                        area: this.form.area,
                    };
                    this.$post(addBusiness,data)
                        .then(res => {
                            window.console.log(res);
                            setTimeout(() => {
                                this.$message.success('提交成功，我们会有工作人员与您联系，请保持电话畅通');
                            }, 1000);
                        })
                        .catch(err => {
                            window.console.log(err);
                            setTimeout(() => {
                                this.$message.error('提交失败，请重新提交');
                            }, 100);
                        })
                }
            })
        }
    }
}
</script>
<style scoped>
    .joinBox{background:url("https://img.xiaochengdaren.com/2019101000750.jpg") right center no-repeat;}
    .joinBox .join-form{ width: 530px;padding:0 35px;height:430px;border-radius:5px;box-shadow:0 0 10px rgba(0,0,0,.1);background:rgba(255,255,255,.8)}
    .joinBox .join-form .title{text-align:center;line-height:80px;font-size:14px;}
    .joinBox .join-form .el-button{width:100%;}
</style>
